 
 
 
import { Action } from '@ngrx/store';

import { SalesOrderPeriod } from '../models/sales-order-period.models';

export enum SalesOrderPeriodActionTypes {
  GetSalesOrderPeriods = '[App] Get sales order periods',
  SetSalesOrderPeriods = '[App] Set sales order periods',
  GetPastSalesOrderPeriods = '[App] Get past sales order periods',
  SetPastSalesOrderPeriods = '[App] Set past sales order periods',
}

export class GetSalesOrderPeriods implements Action {
  readonly type = SalesOrderPeriodActionTypes.GetSalesOrderPeriods;
}

export class SetSalesOrderPeriods implements Action {
  readonly type = SalesOrderPeriodActionTypes.SetSalesOrderPeriods;
  constructor(public readonly salesOrderPeriods: SalesOrderPeriod[]) {}
}

export class GetPastSalesOrderPeriods implements Action {
  readonly type = SalesOrderPeriodActionTypes.GetPastSalesOrderPeriods;
}

export class SetPastSalesOrderPeriods implements Action {
  readonly type = SalesOrderPeriodActionTypes.SetPastSalesOrderPeriods;
  constructor(public readonly pastSalesOrderPeriods: SalesOrderPeriod[]) {}
}

export type SalesOrderPeriodActions =
  | GetSalesOrderPeriods
  | SetSalesOrderPeriods
  | GetPastSalesOrderPeriods
  | SetPastSalesOrderPeriods;
